'use client';
import { useCallback, useEffect } from 'react';
import { YMM } from '../molecules/YMM';
import { YMMType } from '../molecules/YMM/interfaces';
import { ObjectType } from 'typescript';
import { SelectProps } from 'de-sxm-reactlib/components/atoms/Inputs/Select';
import { useYmm20 } from '@/hooks/useYmm2.0';
import Grid from 'de-sxm-reactlib/components/atoms/Layout/Grid/Grid';
import styles from './navYmm.module.scss';

interface Props {
    ymmType?: YMMType;
    selectTheme?: SelectProps<ObjectType>['theme'];
}

export default function NavYMM({ ymmType }: Props) {
    const { ymmTextBar, modal, getYears } = useYmm20();
    const isInfotainment = ymmType && ymmType === YMMType.infotainment;
    const prefix = isInfotainment ? 'Showing infotainment options for ' : undefined;
    const initial = isInfotainment ? <b>vehicles with SiriusXM radios</b> : undefined;

    const showYmmModal = useCallback(
        (type?: string) => {
            if (type === 'infotainment') {
                document.querySelector('html')?.classList.add('showYmm');
            } else {
                document.querySelector('html')?.classList.add('showYmm');
                getYears();
            }
        },
        [getYears],
    );

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const showFromUrl = params.get('ymm') === 'true';

        if (showFromUrl) {
            showYmmModal();
        }
    }, [showYmmModal]);

    if (ymmType === YMMType.infotainment) {
        return (
            <>
                <YMM.Trigger onClick={() => showYmmModal('infotainment')} prefixString={prefix} initialText={initial} />
                <YMM.InfotainmentModal onClose={() => document.querySelector('html')?.classList.remove('showYmm')} />
            </>
        );
    } else if (ymmType === YMMType.standard) {
        return (
            <>
                <Grid container className={styles.containerWrapper}>
                    <Grid className={styles.container} col={{ sm: 12 }}>
                        <span className={styles.ymmTextWrapper}>
                            Showing channels for my
                            <span className={styles.selection}> {ymmTextBar}</span>.
                            <a role="button" onClick={() => showYmmModal()}>
                                Edit
                            </a>
                        </span>
                    </Grid>
                </Grid>
                {modal}
            </>
        );
    } else {
        return <>{modal}</>;
    }
}
